import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { ApiHandlerContract } from '@sparklayer-io/spark-dash-core/types/handlers/api';
import type { CompanyAddress, CompanyAddressRequest } from '../types/address';
import type { CompanyLookup } from '../types/api';

/**
 * A service contract to interact with a specific company address via the SparkLayer API.
 */
export interface CompanyAddressApiContract {
  update(payload: CompanyAddressRequest): Promise<CompanyAddress>;
  delete(): Promise<void>;
}

/**
 * A service to interact with a specific company address via the SparkLayer API.
 */
export class CompanyAddressApi extends ApiService implements CompanyAddressApiContract {
  constructor(
    api: ApiHandlerContract,
    private companyLookup: CompanyLookup,
    private addressId: string,
  ) {
    super(api);
  }

  public update(payload: CompanyAddressRequest): Promise<CompanyAddress> {
    return this.api.proxy({
      method: 'PUT',
      path: '/v2/companies/{lookupBy}/{identifier}/addresses/{addressId}',
      payload,
      params: {
        lookupBy: this.companyLookup.by,
        identifier: this.companyLookup.identifier,
        addressId: this.addressId,
      },
    });
  }

  public delete(): Promise<void> {
    return this.api.proxy({
      method: 'DELETE',
      path: '/v2/companies/{lookupBy}/{identifier}/addresses/{addressId}',
      params: {
        lookupBy: this.companyLookup.by,
        identifier: this.companyLookup.identifier,
        addressId: this.addressId,
      },
    });
  }
}
